<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import PostPreview from './PostPreview'
import ImagePreview from './ImagePreview'
import VideoPreview from './VideoPreview'

export default {
  name: 'LatestPostsTVSlidePreviews',
  components: {
    PostPreview,
    ImagePreview,
    VideoPreview,
  },
  props: {
    previewDataObject: Object,
  },
  computed: {
    isPost() {
      return this.previewDataObject.id && (this.previewDataObject.id.split('-')[0] === 'post')
    },
    isImage() {
      const imageRegex = /(^image)(\/)[a-zA-Z0-9_]*/
      return this.previewDataObject.mimetype && (imageRegex.exec(this.previewDataObject.mimetype))
    },
    preview() {
      return this.isPost ? 'PostPreview' : this.isImage ? 'ImagePreview' : 'VideoPreview'
    },
  },
}
</script>
